import { Component, OnInit } from '@angular/core';
import { CompanyService } from 'src/app/_services/admin/company.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';

@Component({
  selector: 'app-my-company',
  templateUrl: './my-company.component.html',
  styleUrls: ['./my-company.component.css']
})
export class MyCompanyComponent implements OnInit {
 
  constructor(public companyService : CompanyService,
    private loading : LoadingService,
    private notificationService: NotificationService,) { }

  ngOnInit() {
    this.companyService.populate_our_company_form();
    
  }

  onCompanyEditFormSubmit(formData: any)
  {
    if (this.companyService.company_form.valid)
    {
     this.loading.spin$.next(true);
       // Update Data
       //console.log('data updated');
       this.companyService.update_company_details(formData).subscribe(data=>{
         //console.log(data);
         if (data['status']) 
         {
           this.notificationService.success('Company data updated Successfully.');  
           this.loading.spin$.next(false);
         } 
         else 
         {
           this.notificationService.error('Company data could not be updated, Try Again!');
           this.loading.spin$.next(false);
         }
       });
     } 
  }

}
